export const HTS_REGEX = new RegExp(/[0-9]{1,2}/g);
// Anything other than numeric characters and periods is invalid
export const INVALID_HTS_CHARACTERS_REGEX = new RegExp(/[^0-9.]/);
